import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root',
})
export class GeneralService {
  private debugMode = true;

  // Controla si la barra lateral está oculta o no
  splitPaneState = false;

  constructor(private toastService: ToastService) {}

  /**
   * Valida si se está en modo de Debug o no
   *
   * @returns - Si está en modo de Debug o no
   */
  checkDebugMode(): boolean {
    return this.debugMode;
  }

  /**
   * Establece modo de Debug
   *
   * @param mode - Si está en modo de Debug o no
   */
  setDebugMode(mode: boolean) {
    this.debugMode = mode;
  }

  /**
   * Intercala modo debug
   *
   * @returns Valor de modo de debug
   */
  toggleDebugMode(): boolean {
    console.log('debugMode', !this.debugMode);
    return (this.debugMode = !this.debugMode);
  }

  /**
   * Muestra por consola mensajes dependiendo si está en modo de debug o no
   *
   * @param obj - Cualquier todo de objeto a ser desplegado por la consola
   */
  log(...obj: any) {
    if (this.checkDebugMode()) {
      console.log(...obj);
    }
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error); // log to console instead

      this.log(`${operation} failed: ${error.message}`);

      this.toastService.present('(' + error.status + ') ' + error.message, 8000, 'danger');

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  isLocalNetwork(hostname = window.location.hostname) {
    return (
      ['localhost', '127.0.0.1', '', '::1'].includes(hostname) ||
      hostname.startsWith('192.168.') ||
      hostname.startsWith('10.0.') ||
      hostname.endsWith('.local')
    );
  }
}
